/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Play_Injury_FreeInputs */

const en_nav_play_injury_free = /** @type {(inputs: Nav_Play_Injury_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Play Injury Free`)
};

const es_nav_play_injury_free = /** @type {(inputs: Nav_Play_Injury_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Juega sin lesiones`)
};

const de_nav_play_injury_free = /** @type {(inputs: Nav_Play_Injury_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spielen Sie verletzungsfrei`)
};

const zh_nav_play_injury_free = /** @type {(inputs: Nav_Play_Injury_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`无伤打球`)
};

const ar_nav_play_injury_free = /** @type {(inputs: Nav_Play_Injury_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`العب بلا إصابات`)
};

const fr_nav_play_injury_free = /** @type {(inputs: Nav_Play_Injury_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jouer sans blessure`)
};

const vi_nav_play_injury_free = /** @type {(inputs: Nav_Play_Injury_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chơi không chấn thương`)
};

const sw_nav_play_injury_free = /** @type {(inputs: Nav_Play_Injury_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cheza Bila Majeraha`)
};

const th_nav_play_injury_free = /** @type {(inputs: Nav_Play_Injury_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เล่นแบบไร้อาการบาดเจ็บ`)
};

const bs_nav_play_injury_free = /** @type {(inputs: Nav_Play_Injury_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Igraj bez povreda`)
};

const ja_nav_play_injury_free = /** @type {(inputs: Nav_Play_Injury_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ケガなくプレー`)
};

const ko_nav_play_injury_free = /** @type {(inputs: Nav_Play_Injury_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`부상 없이 플레이`)
};

const pt_nav_play_injury_free = /** @type {(inputs: Nav_Play_Injury_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jogue sem lesões`)
};

const it_nav_play_injury_free = /** @type {(inputs: Nav_Play_Injury_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gioca senza infortuni`)
};

const sv_nav_play_injury_free = /** @type {(inputs: Nav_Play_Injury_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spela skadefritt`)
};

const nl_nav_play_injury_free = /** @type {(inputs: Nav_Play_Injury_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Speel zonder blessures`)
};

const da_nav_play_injury_free = /** @type {(inputs: Nav_Play_Injury_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spil skadefrit`)
};

const nb_nav_play_injury_free = /** @type {(inputs: Nav_Play_Injury_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spill skadefritt`)
};

const fi_nav_play_injury_free = /** @type {(inputs: Nav_Play_Injury_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pelaa ilman vammoja`)
};

const pl_nav_play_injury_free = /** @type {(inputs: Nav_Play_Injury_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Graj bez kontuzji`)
};

const ru_nav_play_injury_free = /** @type {(inputs: Nav_Play_Injury_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Играйте без травм`)
};

const tr_nav_play_injury_free = /** @type {(inputs: Nav_Play_Injury_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sakatlanmadan oyna`)
};

const hi_nav_play_injury_free = /** @type {(inputs: Nav_Play_Injury_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`चोट के बिना खेलें`)
};

const id_nav_play_injury_free = /** @type {(inputs: Nav_Play_Injury_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bermain tanpa cedera`)
};

const ms_nav_play_injury_free = /** @type {(inputs: Nav_Play_Injury_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bermain tanpa kecederaan`)
};

const cs_nav_play_injury_free = /** @type {(inputs: Nav_Play_Injury_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hrajte bez zranění`)
};

const el_nav_play_injury_free = /** @type {(inputs: Nav_Play_Injury_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Παίξτε χωρίς τραυματισμούς`)
};

const he_nav_play_injury_free = /** @type {(inputs: Nav_Play_Injury_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`שחקו ללא פציעות`)
};

const af_nav_play_injury_free = /** @type {(inputs: Nav_Play_Injury_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Speel sonder beserings`)
};

const hu_nav_play_injury_free = /** @type {(inputs: Nav_Play_Injury_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Játssz sérülés nélkül`)
};

/**
* | output |
* | --- |
* | "Play Injury Free" |
*
* @param {Nav_Play_Injury_FreeInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const nav_play_injury_free = /** @type {((inputs?: Nav_Play_Injury_FreeInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Play_Injury_FreeInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_nav_play_injury_free(inputs)
	if (locale === "de") return de_nav_play_injury_free(inputs)
	if (locale === "zh") return zh_nav_play_injury_free(inputs)
	if (locale === "ar") return ar_nav_play_injury_free(inputs)
	if (locale === "fr") return fr_nav_play_injury_free(inputs)
	if (locale === "vi") return vi_nav_play_injury_free(inputs)
	if (locale === "sw") return sw_nav_play_injury_free(inputs)
	if (locale === "th") return th_nav_play_injury_free(inputs)
	if (locale === "bs") return bs_nav_play_injury_free(inputs)
	if (locale === "ja") return ja_nav_play_injury_free(inputs)
	if (locale === "ko") return ko_nav_play_injury_free(inputs)
	if (locale === "pt") return pt_nav_play_injury_free(inputs)
	if (locale === "it") return it_nav_play_injury_free(inputs)
	if (locale === "sv") return sv_nav_play_injury_free(inputs)
	if (locale === "nl") return nl_nav_play_injury_free(inputs)
	if (locale === "da") return da_nav_play_injury_free(inputs)
	if (locale === "nb") return nb_nav_play_injury_free(inputs)
	if (locale === "fi") return fi_nav_play_injury_free(inputs)
	if (locale === "pl") return pl_nav_play_injury_free(inputs)
	if (locale === "ru") return ru_nav_play_injury_free(inputs)
	if (locale === "tr") return tr_nav_play_injury_free(inputs)
	if (locale === "hi") return hi_nav_play_injury_free(inputs)
	if (locale === "id") return id_nav_play_injury_free(inputs)
	if (locale === "ms") return ms_nav_play_injury_free(inputs)
	if (locale === "cs") return cs_nav_play_injury_free(inputs)
	if (locale === "el") return el_nav_play_injury_free(inputs)
	if (locale === "he") return he_nav_play_injury_free(inputs)
	if (locale === "af") return af_nav_play_injury_free(inputs)
	if (locale === "hu") return hu_nav_play_injury_free(inputs)
	return en_nav_play_injury_free(inputs)
});